import React from 'react';

const phrases = [
  'Automate your hiring with prepxai',
  'Interview 500, not 50, to get your best candidate',
  'Custom scoring filters at every stage',
  'Upload resumes. Launch pipelines. Hire faster.',
  'AI that learns from your hiring decisions',
];

const BusinessTaglineMarquee = () => {
  const doubled = [...phrases, ...phrases];

  return (
    <section className="border-y border-[var(--lp-line)] bg-white py-5 overflow-hidden">
      <div className="lp-marquee flex w-max gap-12 whitespace-nowrap">
        {doubled.map((phrase, i) => (
          <span
            key={`${phrase}-${i}`}
            className="flex items-center gap-12 font-mono text-xs tracking-wider text-[var(--lp-ink-soft)]"
          >
            {phrase}
            <span className="h-1 w-1 rounded-full bg-[var(--lp-accent)]" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default BusinessTaglineMarquee;
